import { ReactElement } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import thematize from 'lib/thematize';
import { useEsc, useModal, useSelector } from 'hooks';
import { setDialogModal } from 'slices/app';
import Button from 'components/Base/Button';
import { COLORS } from 'components/Base/constants';
import Dialog from 'components/Base/Dialog';
import Icon from 'components/Icon';
import { downloadDocx } from 'components/ProfileActions/downloadDocx';
import { downloadPdf } from 'components/ProfileActions/downloadPdf';
import messages from './messages';
import styles from './MergeExportError.scss';

const theme = thematize(styles);

const MergeExportError = (): ReactElement => {
  const { closeModal } = useModal();
  const { formatMessage, formatDate } = useIntl();
  // профиль есть только при экспорте из карточки — из папки скачивать нечего
  const profile = useSelector(({ profileMain }) => profileMain.profile);

  useEsc(closeModal);

  const handleDownload = (type: 'docx' | 'pdf') => (): void => {
    if (!profile) return;

    const download = type === 'pdf' ? downloadPdf : downloadDocx;

    download({ profile, formatMessage, formatDate });
  };

  return (
    <Dialog>
      <Dialog.Title className={theme('title')}>
        <FormattedMessage {...messages.title} />
        <div className={theme('close')} onClick={closeModal}>
          <Icon kind="cross" size="small" />
        </div>
      </Dialog.Title>
      <Dialog.Content>
        <div className={theme('text')}>
          <FormattedMessage {...messages.apology} />
        </div>
        <div className={theme('text')}>
          <FormattedMessage {...messages.reason} />
        </div>
        <div className={theme('text')}>
          <FormattedMessage {...messages.action} />
        </div>
      </Dialog.Content>
      <Dialog.Actions>
        <div className={theme('buttons')}>
          {profile && (
            <>
              <Button appearance="outlined" onClick={handleDownload('pdf')}>
                <FormattedMessage {...messages.downloadPdf} />
              </Button>
              <Button appearance="outlined" onClick={handleDownload('docx')}>
                <FormattedMessage {...messages.downloadDocx} />
              </Button>
            </>
          )}
          <Button color={COLORS.primary} onClick={closeModal}>
            <FormattedMessage {...messages.close} />
          </Button>
        </div>
      </Dialog.Actions>
    </Dialog>
  );
};

/** Попап с объяснением, что упал внешний провайдер Merge, а не наш экспорт */
export const mergeExportErrorModal = () =>
  setDialogModal({ show: true, content: <MergeExportError /> });

export default MergeExportError;
